import { inject, Injectable } from '@angular/core';
import { ApolloQueryResult } from '@apollo/client/core';
import { map, Observable, of, switchMap } from 'rxjs';

import { OrderDetailsResponse } from '../models/order-details-response.model';
import { MyOrderDetailsPricelessQuery } from '../queries/my-order-details-priceless.query';
import { MyOrderDetailsQuery } from '../queries/my-order-details.query';
import { OrderDetailsPricelessQuery } from '../queries/order-details-priceless.query';
import { OrderDetailsQuery } from '../queries/order-details.query';
import { OrderJobQuery } from '../queries/order-job.query';

@Injectable({
  providedIn: 'root',
})
export class OrderService {
  #myorderDetailsQuery: MyOrderDetailsQuery = inject(MyOrderDetailsQuery);
  #myorderDetailsPricelessQuery: MyOrderDetailsPricelessQuery = inject(MyOrderDetailsPricelessQuery);
  #orderDetailsPricelessQuery: OrderDetailsPricelessQuery = inject(OrderDetailsPricelessQuery);
  #orderDetailsQuery: OrderDetailsQuery = inject(OrderDetailsQuery);
  #orderJobQuery: OrderJobQuery = inject(OrderJobQuery);

  getOrderByKey(
    orderNumber: string,
    locale: string,
    includePrice: boolean,
  ): Observable<ApolloQueryResult<OrderDetailsResponse>> {
    const orderDetails$ = includePrice
      ? this.#orderDetailsQuery.fetch(
          { orderNumber, locale, includePrice, ct_Locale: locale },
          { fetchPolicy: 'network-only' },
        )
      : this.#orderDetailsPricelessQuery.fetch(
          { orderNumber, locale, ct_Locale: locale },
          { fetchPolicy: 'network-only' },
        );

    return orderDetails$.pipe(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      switchMap((orderDetails: ApolloQueryResult<any>) => {
        const jobKey = orderDetails?.data?.order?.jobKey;

        if (jobKey !== '00000000-0000-0000-0000-000000000000') {
          return this.#orderJobQuery.fetch({ jobKey }, { fetchPolicy: 'network-only' }).pipe(
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            map((orderJob: ApolloQueryResult<any>) => {
              return {
                ...orderDetails,
                data: {
                  order: {
                    ...orderDetails.data.order,
                    job: orderJob?.data?.job,
                  },
                },
              };
            }),
          );
        } else {
          return of(orderDetails);
        }
      }),
    ) as Observable<ApolloQueryResult<OrderDetailsResponse>>;
  }

  getMyOrderByKey(
    orderNumber: string,
    locale: string,
    includePrice: boolean,
  ): Observable<ApolloQueryResult<OrderDetailsResponse>> {
    return includePrice
      ? this.#myorderDetailsQuery.fetch(
          { orderNumber, locale, includePrice, ct_Locale: locale },
          { fetchPolicy: 'network-only' },
        )
      : this.#myorderDetailsPricelessQuery.fetch(
          { orderNumber, locale, ct_Locale: locale },
          { fetchPolicy: 'network-only' },
        );
  }
}
